/**
 * 与store的unshow模块强关联，专注于dom是否展示
 */
import Vue from 'vue'
import store from '@/store'

function func (el, binding) {
  const unshowArr = store.state.unshow.unshowArr

  // 如果没有匹配关闭功能，则正常
  if (!unshowArr.includes(binding.arg)) {
    return
  }

  // 删除掉该节点，兼容处理
  if (el.parentNode) {
    el.parentNode.removeChild(el)
    return
  }
  el.style.display = 'none'
}

Vue.directive('unshow', {
  inserted: func,
  update: func // 防止以后更新数据出问题
})
